/**
 * ProductDetails — description & vendor/type metadata
 */
import { useTranslation } from "react-i18next";

interface ProductDetailsProps {
  descriptionHtml?: string | null;
  vendor?: string | null;
  productType?: string | null;
}

export function ProductDetails({
  descriptionHtml,
  vendor,
  productType,
}: Readonly<ProductDetailsProps>) {
  const { t } = useTranslation();

  return (
    <div className="mt-10 divide-y divide-border-6 rounded-3xl bg-white px-6 max-mobile:px-5">
      {/* Description */}
      {descriptionHtml && (
        <div className="py-6">
          <h2 className="mb-3 text-base font-bold text-text-1">
            {t("SingleProductPage.description")}
          </h2>
          <div
            className="blog-article-content prose prose-sm max-w-none text-text-3"
            dangerouslySetInnerHTML={{ __html: descriptionHtml }}
          />
        </div>
      )}

      {/* GPSR (EU) 2023/988 art. 19(a): manufacturer name and postal and email address on every product offer. */}
      <div className="py-6">
        <h2 className="mb-3 text-base font-bold text-text-1">
          {t("SingleProductPage.manufacturer")}
        </h2>
        <address className="text-small text-text-3 not-italic leading-relaxed">
          HONOPONO j.d.o.o. (Postolar Varga)
          <br />
          Osječka ulica 148, 31207 Tenja,{" "}
          {t("SingleProductPage.manufacturerCountry")}
          <br />
          <a href="mailto:postolar.varga@gmail.com" className="hover:underline">
            postolar.varga@gmail.com
          </a>
        </address>
      </div>

      {/* Vendor / Type */}
      {/* {(vendor || productType) && (
        <div className="mt-6">
          <h2 className="text-text-1 mb-2 font-semibold">
            {t("SingleProductPage.details")}
          </h2>
          <dl className="text-text-3 space-y-1">
            {vendor && (
              <div className="flex gap-1">
                <dt className="font-medium">
                  {t("SingleProductPage.vendor")}:
                </dt>
                <dd>{vendor}</dd>
              </div>
            )}
            {productType && (
              <div className="flex gap-1">
                <dt className="font-medium">
                  {t("SingleProductPage.type")}:
                </dt>
                <dd>{productType}</dd>
              </div>
            )}
          </dl>
        </div>
      )} */}
    </div>
  );
}
